import { h, withDirectives } from 'vue';
import state from '@/state';
import maxLines from '@/utils/directives/maxLines';

const supportsLineClamp = typeof CSS !== 'undefined' && CSS.supports('display', '-webkit-box');
if (process.env.NODE_ENV === 'development') {
  console.log('supportsLineClamp', supportsLineClamp);
}

export default {
  props: ['value', 'maxLines'],

  data: () => ({
    state,
  }),

  methods: {
    escape(s) {
      if (!this.state.merchantConfig.widgets.enableCommentLinks) {
        return [s];
      }

      const re = /(.*)(http(?:s?):\/\/(?:[^\s\\]+)\.[^)\s\\]+)(.*)/ig;

      const parts = [];

      for (const match of s.matchAll(re)) {
        if (match[1]) parts.push(...this.escape(match[1]))
        parts.push(h('a', { href: match[2], innerText: `${match[2]}`, target: '_blank', class: 'gmf-link' }))
        if (match[3]) parts.push(...this.escape(match[3]))
      }

      if (parts.length === 0) {
        return [s];
      }

      return parts;
    }
  },

  render() {
    if (!this.value) return;

    const lines = this.value.split('\n');

    const style = {
      'white-space': 'pre-wrap',
      'word-break': 'break-word',
    };

    if (this.maxLines && supportsLineClamp) {
      Object.assign(style, {
        'display': ['-webkit-box', '-moz-box', 'box'],
        '-webkit-line-clamp': this.maxLines,
        '-webkit-box-orient': 'vertical',
        '-moz-line-clamp': this.maxLines,
        '-moz-box-orient': 'vertical',
        'line-clamp': this.maxLines,
        'box-orient': 'vertical'
      });
    }

    const vnode = h('div', {
      style,
    }, lines.map(l => {
      let r = this.escape(l, h);
      if (Array.isArray(r)) {
        r.push('\n');
      } else {
        r += '\n';
      }
      
      return r;
    }));

    if (this.maxLines && !supportsLineClamp) {
      return withDirectives(vnode, [[maxLines, this.maxLines, 'ellipsis']]);
    }

    return vnode;
  },
}
